<template>
    <PopoverRight ref="popoverMenu" width="550px">
        <div class="popover-slider-bar">
            <h1 class="bar-title">代理商签约</h1>
            <el-form class="form-container" :model="factorInfo" :rules="factorRules" ref="userInfoForm1">
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">签约站点</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item">
                        <el-form-item prop="checkedSites">
                            <site-auto-complete :factor-id="1" v-model="factorInfo.site_selected" @change="changeSites">
                            </site-auto-complete>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-select-checked-container">
                    <p v-for="(tag, key) in checkedSites" :key="key" class="item">
                        {{ tag.name }}
                        <i class="el-icon-close" @click.stop.prevent="removeChecked(key)"></i>
                    </p>
                </div>
                <div class="form-select-site">
                    <el-card class="box-card" v-for="(item, key) in checkedSites" :key="key">
                        <div>
                            <span style="font-size:18px;margin-left:30px;font-weight: bold;">{{ item.name }}</span>
                            <i class="el-icon-close" @click.prevent="removeChecked(key)"></i>
                        </div>
                        <div class="form-item">
                            <div class="form-label">
                                <span class="label">签约时间</span>
                                <label class="warn">*</label>
                            </div>
                            <div class="form-input-item">
                                <el-form-item label="">
                                    <el-date-picker v-model="checkedSites[key].signDate" type="daterange"
                                        range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                                    </el-date-picker>
                                </el-form-item>
                            </div>
                        </div>
                    </el-card>
                </div>

                <div class="form-button">
                    <el-button type="primary" @click="submitForm('userInfoForm1')">确 认</el-button>
                    <el-button type="info" plain @click.stop.prevent="hide">取 消</el-button>
                </div>
            </el-form>
        </div>
    </PopoverRight>
</template>

<script>
import PopoverRight from '@/components/popoverRight/index'
import { modifyFactorStatus, modifyFactorSites } from '@/service/user'
import SiteAutoComplete from "../../../../components/auto-complete/site-auto-complete";

export default {
    name: "signFactor",
    components: {
        PopoverRight,
        SiteAutoComplete
    },
    props: {
        callback: Function
    },
    methods: {

        changeSites(id) {
            const site = this.data.find(data => data.id === id);
            if (site && this.checkedSites.findIndex(data => data.id === id) < 0) {
                this.checkedSites.push(site)
            }
        },
        removeChecked(index) {
            this.checkedSites.splice(index, 1);
            this.factorInfo.site_selected = this.checkedSites.length > 0 ? this.checkedSites[0].id : ''
        },
        open() {
            if (this.factorInfo.sign_start_time && this.factorInfo.sign_end_time) {
                this.factorInfo.signDate = [
                    new Date(this.factorInfo.sign_start_time * 1000),
                    new Date(this.factorInfo.sign_end_time * 1000)
                ]
            }
            this.$refs.popoverMenu && this.$refs.popoverMenu.open()
        },
        /** 关闭右侧悬浮层 */
        hide() {
            this.$refs.popoverMenu && this.$refs.popoverMenu.hide();
            this.resetForm();
            this.$refs.userInfoForm1 && this.$refs.userInfoForm1.clearValidate()
        },
        resetForm() {
            this.checkedSites = [];
            this.factorInfo = {
                id: 0,
                name: '',
                site: [],
                signDate: [],
                sites: [],
                site_selected: '',
                datas: this.factorInfo.datas
            }
        },
        init() {
            //this.callback();
        },
        submitForm(formName) {

            this.$refs[formName].validate(async (valid) => {

                if (valid) {

                    let query = {
                        "status": 1,
                    };
                    let status = 0;
                    await modifyFactorStatus(this.factorInfo.id, query).then((data) => {
                        status = 1;
                    }).catch(err => {
                        this.$message({
                            message: err.message || '签约失败',
                            type: 'error',
                            duration: 3 * 1000
                        })
                    });
                    if (!status) {
                        return false;
                    }
                    let sites = [];
                    this.checkedSites.forEach(el => {
                        let site = {};
                        site.id = el.id;
                        site.sign_start_time = new Date(el.signDate[0]).getTime() / 1000;
                        site.sign_end_time = new Date(el.signDate[1]).getTime() / 1000 + 86400 - 1;
                        sites.push(site)
                    });
                    let param = {};
                    param.sites = sites
                    await modifyFactorSites(this.factorInfo.id, param).then((data) => {
                        this.$message({
                            message: '站点绑定成功',
                            type: 'success',
                            duration: 3 * 1000
                        })
                    }).catch(err => {
                        this.$message({
                            message: err.message || '站点绑定签约失败',
                            type: 'error',
                            duration: 3 * 1000
                        })
                    });
                    this.resetForm();
                    this.hide();
                    this.callback && this.callback();
                } else {
                    return false
                }
            })
        },
    },
    data() {
        let validDate = (rule, value, callback) => {
            if (!value || !value[0] || !value[1]) {
                callback(new Error("请选择时间"))
            } else if (value[0] >= value[1]) {
                callback(new Error("结束时间必须大于开始时间"))
            } else {
                callback()
            }
        }
        let validateSite = (rule, value, callback) => {
            if (this.checkedSites.length <= 0) {
                callback(new Error(rule.message))
            } else {
                callback()
            }
        }
        return {
            checkedSites: [],
            factorInfo: {
                id: 0,
                name: '',
                site: [],
                signDate: [],
                sites: [],
                site_selected: '',
                datas: [],
            },
            data: [
            ],
            factorRules: {
                signDate: [
                    { validator: validDate, trigger: 'blur' }
                ],
                checkedSites: [
                    { validator: validateSite, message: '请选择站点', trigger: 'change' },
                ],
            },
        }
    }

}
</script>

<style scoped>

</style>
